import { FC } from 'react';
import { Box, Button, Divider, Stack } from '@mui/material';
import { CarModel } from '@services/car-model';
import { Tr } from '@utils/translation';
import { CarModelInfo } from '../CarModelInfo';
import { FleetVehicle } from '@services/fleet-vehicle';
import { SimulationVehicle } from '@services/simulation';

export interface ISelectableSingleModelnfoProps {
	vehicle: FleetVehicle;
	simulationVehicle: SimulationVehicle;
	selected?: boolean;
	vehiclePriceVisible?: boolean;
	onSelectChange?: (model: CarModel, action: 'select' | 'deselect') => void;
}

export const SelectableSingleModelnfo: FC<ISelectableSingleModelnfoProps> = ({
	vehicle,
	simulationVehicle,
	selected,
	vehiclePriceVisible,
	onSelectChange
}) => {
	return (
		<Stack
			direction="column"
			sx={{ maxHeight: 1.0, width: 1.0, overflowY: 'hidden', backgroundColor: 'common.black', borderRadius: 5 }}
		>
			<CarModelInfo
				mode="compare"
				vehicle={vehicle}
				simulationVehicle={simulationVehicle}
				vehiclePriceVisible={vehiclePriceVisible}
				color="common.white"
				primaryColor="common.black"
				secondaryColor={selected ? '#53597c' : 'grey.800'}
				sx={{
					flexGrow: 1,
					maxHeight: 1.0,
					overflowY: 'auto',
					borderTopLeftRadius: 20,
					borderTopRightRadius: 20,
					...(selected
						? {
								backgroundColor: 'transparent',
								backgroundImage: ({ palette }) =>
									`linear-gradient(to bottom, ${palette.primary.main}4f 27%, ${palette.common.black} 135%)`
						  }
						: {})
				}}
			/>
			<Divider />
			<Box sx={{ paddingX: 6, paddingY: 2, width: 1.0, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
				<Button
					variant="light"
					size="small"
					fullWidth
					onClick={() => onSelectChange?.(simulationVehicle.carModel, selected ? 'deselect' : 'select')}
					data-testid="conversion-list-select-deselect-button"
				>
					<Tr.Portal path={selected ? 'remove' : 'select'} />
				</Button>
			</Box>
		</Stack>
	);
};
